import React from 'react';
import './image-switcher.scss';
import PropTypes from 'prop-types';
import Icon from '../../mweb/Icon/Icon';

const ImageSwitcher = props => {
  const { onNext, onPrevious } = props;
  return (
    <React.Fragment>
      <div className="image-switch left" onClick={onPrevious}>
        <Icon class="icon-back-bar-back" size={20} />
      </div>
      <div className="image-switch right" onClick={onNext}>
        <Icon class="icon-back-bar-back right-arrow" size={20} />
      </div>
    </React.Fragment>
  );
};

ImageSwitcher.propTypes = {
  onNext: PropTypes.func.isRequired,
  onPrevious: PropTypes.func.isRequired,
};

export default ImageSwitcher;
